import * as tslib_1 from "tslib";
import { ApplicationInfoDto } from '@/lib/service-proxy/ApplicationInfoDto';
import { SessionServiceProxy } from '@/lib/service-proxy/SessionServiceProxy';
var SessionStore = /** @class */ (function () {
    function SessionStore() {
        this.namespaced = true;
        this.state = {
            application: new ApplicationInfoDto(),
            user: null,
            tenant: null,
            member: null,
            sessionService: new SessionServiceProxy()
        };
        this.actions = {
            init: function (context) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var response;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, context.state.sessionService.getCurrentLoginInformations()];
                            case 1:
                                response = _a.sent();
                                context.state.application = response.application;
                                context.state.user = response.user;
                                context.state.tenant = response.tenant;
                                return [2 /*return*/];
                        }
                    });
                });
            }
        };
    }
    return SessionStore;
}());
var session = new SessionStore();
export default session;
